/**
 * @ngdoc Controller
 */

import {localeMeta} from '@/languages/meta';

(function() {
    'use strict';

    angular.module('vrm.components')
        .controller('LangSelectorController', LangSelectorController);

    /* @ngInject */
    function LangSelectorController($scope, VrmLangService, close, locale) {
        $scope.languages = localeMeta.languages.map(l => l.code);

        $scope.getLanguageTitle = (code) => {
            const lang = localeMeta.getByCode(code);
            return lang && lang.label ? lang.label : locale.getString(`language.${code}`);
        }

        $scope.selector = {
            lang: null
        };

        VrmLangService.getLang().then(function(lang) {
            $scope.selector.lang = lang;
            var initial = true;
            $scope.$watch('selector.lang', function(lang) {
                if (initial) {
                    initial = false;
                } else {
                    VrmLangService.setLang(lang);
                }
            });
        });

        return {
            close: close
        };
    }

})();
